import React, { useState } from "react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import type { UnitFeature } from "@/types";

interface UnitFeaturesProps {
    features: UnitFeature[];
    tier?: string;
}

export const UnitFeatures: React.FC<UnitFeaturesProps> = ({ features, tier }) => {
    const bgClass = tier === "tierB" ? "tw:before:bg-[var(--secondary)]" : "tw:before:bg-[var(--primary)]";

    const [openId, setOpenId] = useState<number | null>(null);

    return features.length > 0 ? (
        <ul className="unit-item-features">
            {features.map((feature) => (
                <li key={feature.id} className={`${bgClass} unit-item-features__item`} id={`feature-${feature.id}`}>
                    {feature.description ? (
                        <TooltipProvider>
                            <Tooltip
                                open={openId === feature.id}
                                onOpenChange={(isOpen) => setOpenId(isOpen ? feature.id : null)}
                            >
                                <TooltipTrigger asChild>
                                    <span
                                        onClick={() =>
                                            setOpenId(openId === feature.id ? null : feature.id)
                                        }
                                    >
                                        <span className="feature-icon"></span>
                                        {feature.name}
                                    </span>
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>{feature.description}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    ) : (
                        <span>{feature.name}</span>
                    )}
                </li>
            ))}
        </ul>
    ) : null;
};